<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>未収お客さま検索画面</h1>

<!-- 検索条件コンポーネント -->
<form [formGroup]="searchReqForm" (ngSubmit)="search()">
  <sgke300d-search-condition *ngIf="cmpnyAreaList" [cmpnyAreaList]="cmpnyAreaList" [cmpnyAreaInit]="cmpnyAreaInit" [searched]="searched" [businessDate]="businessDate"
    (onClickClearEvent)="clear()">
  </sgke300d-search-condition>
</form>

<!-- 検索結果コンポーネント -->
<sgke300d-search-result *ngIf="searched" [searchResultList]="searchResultList"
  (onDblClickRowEvent)="navigateBill($event)">
</sgke300d-search-result>